import * as React from 'react';
import {DataGrid, GridActionsCellItem} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import {useDispatch, useSelector} from "react-redux";
import {fetchPermission, setConfig, EditPermission} from "../../index";
import {setRightDrawer} from "../../../../Common/App";
import {StatusBall} from "../../../../../Components/Elements/StatusBall";
import useDeepEqualSelector from "../../../../../Hooks/useDeepEqualSelector";

export const PermissionTable = ({ isLoading, setIsLoading }) => {

    const dispatch = useDispatch();
    const items = useSelector((store) => store.permissions.list);
    const config = useDeepEqualSelector((store) => store.permissions.config);
    console.log(config);
    const editItem = React.useCallback(
        (id) => () => {
            fetchPermission({dispatch, id});
            dispatch(setRightDrawer({component:<EditPermission />, open:true}))
        },
        [dispatch],
    );

    const columns = React.useMemo(
        () => [
            { field: 'name', headerName:'Permissions Name', type: 'string', minWidth:300, flex: 1 },
            { field: 'label', headerName:'Label', type: 'string', minWidth: 300, flex:1 },
            { field: 'type', headerName:'Type', type: 'string', flex:1, minWidth: 130,
                renderCell: (params) => ( params.value === 'menu' ? <StatusBall label="Menu" size="small" color="primary" /> : <StatusBall label="Feature" size="small" color="warning" />)
            },
            { field: 'group', headerName:'Group', type: 'string', flex:1, minWidth: 180 },
            {
                field: 'actions',
                type: 'actions',
                headerName:'Action',
                flex:1,
                minWidth: 120,
                getActions: (params) => [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        onClick={editItem(params.id)}
                    />,
                ],
            },
        ],
        [editItem],
    );

    return (
        <DataGrid
            loading={isLoading}
            rows={items || []}
            getRowId={(row) => row.id}
            rowHeight={60}
            columns={columns}
            pagination
            paginationMode="server"
            paginationModel={config.pagination}
            rowCount={config?.total ?? 0}
            pageSizeOptions={[5, 10, 25, 100]}
            onPaginationModelChange={(params) => !isLoading && (setIsLoading(true) || dispatch(setConfig({ pagination: { ...config.pagination, page: params.page, pageSize: params.pageSize } })))}
            initialState={{
                columns:{
                    columnVisibilityModel:{
                        id:false,
                    }
                },
                sorting: {
                    sortModel: [{ field: 'group', sort: 'asc' }],
                },
                pagination: { paginationModel: { ...config.pagination } }
            }}
        />
    );
}
